// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".container___VSSAR{width:calc(50% - 16px);margin-right:16px}\n", "",{"version":3,"sources":["webpack://./src/routes/Reports/components/TransactionVolumeDashlet/TransactionVolumeDashlet.css"],"names":[],"mappings":"AAAA,mBACI,sBAAA,CACA,iBAAA","sourcesContent":[".container {\n    width: calc(50% - 16px);\n    margin-right: 16px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": "container___VSSAR"
};
export default ___CSS_LOADER_EXPORT___;
